export default "__VITE_ASSET__C_iR4ENV__"